//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.PredanaDoslaPostaListPage.ts         </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-01-05                                                  </Created>
//  </FileHeader>


namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class PredanaDoslaPostaListPage extends GContentBase<PodDokSpisListBasePage>
    {
        model: Wfl.Interface.GPredanoFilterDto;

        onContentReady() {
            var that = this;
            PodDokSpisListBasePage.InitList(this);
            this.printActions.push(this.CreateActionTisPredaneDoslePosty());
            //this.specialActions.push(this.CreateActionVyjmoutZeSpisovny());
            //this.specialActions.push(this.CreateActionVlozitDoBaliku());

            //this.specialActions.push(SpiListBaseAC.CreateActionZmenitSpisovyZnak(this, false, true));

            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: "all",
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_dspreo" }),
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"
                })

            this.CreateGrid();
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)
        }

        CreateFilterForms() {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); //RC 26285623 : Filtr balíků
            filterForm.addSection();
            filterForm.addRow({ layoutDescriptor: "w-6" }).addField("gdatecombobox", {
                name: "DatumField",
                model: "model.Datum=value.date",
                defaultInitialValue: "all",
                daysRangeMax: this.DaysRangeMax,
                contextMenu: {
                    daysRange: 50
                },
                userSettings: this.userSettings,
            });
            filterForm.addRow({ label: "jres:23900130" }).addField("gselectbox", Gin.Prefabs.Field.SpisovyUzel(Gin.Prefabs.Field.MergeOptions({ //RC 23900130 : Předáno na spisový uzel
                name: "PredanoIxsSu", model: "model.Prevzal.{0} = value.{1}".format("ixs_su", Gordic.Data.Readers.GinspodDtoNames.ixs_su)
                // 26.03.2020 - TFeik
                // Doplněn příznak zda se spisový uzel používá v redistribuci / předání.
            }), false))
            return [filterForm];
        }

        LoadData(filtr?: Wfl.Interface.GPredanoFilterDto) {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            //nacteni dat do gridu
            this.model = $.extend({}, this.model, filtr);
            this.call<Wfl.Interface.DokSpisListDto[]>("LoadData", { "model": this.model })
                .done(function (data) {
                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    that.mainGrid.ggrid("setData", view);
                })
                .always(function () { Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that); });
        }

        ReloadData() {
            this.LoadData(this.model);
        }

        CreateGrid()
        {
            var gf = Wfl.ListAC.WflListBaseAC.GetGridFormat();
            gf.addIconColumn(Gordic.Wfl.Globals.ListSupport.EleColumn());
            gf.addTextColumn(Wfl.ListPrefabs.ixpColumn());
            gf.addDateTimeColumn(Wfl.ListPrefabs.datPrijPodaniColumn(""));
            gf.addTextColumn(Wfl.ListPrefabs.znackaColumn(this.LabelZnacka));
            gf.addTextColumn(Wfl.ListPrefabs.odesilatelColumn());
            gf.add(Wfl.ListPrefabs.vecColumn());
            gf.addNumberColumn(Wfl.ListPrefabs.porCisloColumn());
            gf.addTextColumn(Wfl.ListPrefabs.PredanoSuColumn());
            gf.addDateColumn(Wfl.ListPrefabs.datPredaniColumn());
            gf.addTextColumn(Wfl.ListPrefabs.aktualniVlastnikColumn());
            gf.addTextColumn(Wfl.ListPrefabs.typDokumentuTxtColumn());  
            gf.addTextColumn(Wfl.ListPrefabs.typAgendyTxtColumn());  

            if (this.mainGrid) this.mainGrid.remove();
            this.mainGrid = Wfl.ListAC.DokSpisListBaseAC.GetGridDokSpis(this, gf);
            Wfl.ListAC.WflListBaseAC.AfterCreateGrid(this);
        }

        CreateActionTisPredaneDoslePosty(): GAction
        {
            var that = this;

            var action = new GAction({
                name: Pod.Globals.ActionsName.tiskPredaneDoslePosty,
                icon: Gordic.Gin.Icons.ActionEnum.tisk,
                caption: "jres:23900131", //RC 23900131 : Tisk předané došlé pošty
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function ()
                {
                    var act = GAction.createPrintAction({
                        name: "dlgTisk",
                        caption: "jres:23900131", //RC 23900131 : Tisk předané došlé pošty
                        tema: "ssl_ptm_prdmz",
                        reportStarting: function (rep) {
                            rep.params.X0000 = that.model.Prevzal.ixs_su;
                            rep.params.X0001 = Gin.Globals.GetDateStartToString(that.model.Datum);
                            rep.params.X0002 = Gin.Globals.GetDateEndToString(that.model.Datum);
                        }
                    });
                    act.run();
                }
            });

            //action.enabled(false);
            return action;
        }

    }
};
